import { useEffect } from 'react';
import posthog from 'posthog-js';

export function initPostHog() {

  if (typeof window !== 'undefined' && !posthog.__loaded) {
    posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
      api_host: '/ingest',
      ui_host: 'https://us.posthog.com',
      person_profiles: 'identified_only',
      capture_pageview: true,
      capture_pageleave: true,
      capture_exceptions: true,
      debug: process.env.NODE_ENV === 'development',
      loaded: (ph) => {
        // Opt out for localhost, Vercel previews, and Google Translate
        const hostname = window.location.hostname;
        if (
          hostname === 'localhost' ||
          hostname.endsWith('.vercel.app') ||
          hostname.endsWith('.translate.goog')
        ) {
          ph.opt_out_capturing();
          if (process.env.NODE_ENV === 'development') {
            console.log('PostHog: opted out (localhost/preview/translate)');
          }
        }

        // Register global properties
        ph.register({
          site: 'soroswap_landing',
          lang: document.documentElement.lang || navigator.language
        });

        if (process.env.NODE_ENV === 'development') {
          console.log('PostHog loaded successfully');
        }
      }
    });
  }
}

export function PostHogProvider({ children }) {
  useEffect(() => {
    initPostHog();
  }, []);

  return children;
}
